import { DaysOfWeek } from './common';

export enum INSURANCE_TYPE {
    PUBLIC = 'PUBLIC',
    PRIVATE = 'PRIVATE',
    DIRECT_PAYER = 'DIRECT_PAYER',
}

export enum CARE_LEVEL {
    NONE = 'NONE',
    APPLYING_FOR = 'APPLYING_FOR',
    ONE = 'ONE',
    TWO = 'TWO',
    THREE = 'THREE',
    FOUR = 'FOUR',
    FIVE = 'FIVE',
}
export class AddressDTO {
    street: string;
    streetNumber: string;
    addressSuffix: string;
    city: string;
    zip: string;
    country: string;
    region: string;
    district: string;
    latitude: number;
    longitude: number;
}

export class ResidienceDTO {
    type: string;
    access: string;
    notes: string;
    keyNumber: string;
    keySite: string;
}

export class CohabitingSituationDTO {
    withPartner = false;
    withChildren = false;
    withOtherRelatives = false;
    withDogs = false;
    withCats = false;
    withDangerousAnimals = false;
    withHarmlessAnimals = false;
}

export class HealthInsuranceDTO {
    insurer: string;
    insuranceNumber: string;
    // insuranceType: INSURANCE_TYPE = INSURANCE_TYPE.PUBLIC;
    insuranceType: INSURANCE_TYPE;
    kvNumber: string;
}

export class AnamnesisDTO {
    medications: [string];
    diseases: string[] = [];
    noAnamnesisInfo: boolean = true;
    otherDiseases: string;
    allergyStatus: string;
    allergies: string[] = [];
}

export class MedicalUserDataDTO {
    healthInsurance: HealthInsuranceDTO;
    // careLevel: CARE_LEVEL = CARE_LEVEL.NONE;
    careLevel: CARE_LEVEL;
    anamnesis: AnamnesisDTO;
    medicationLocation: string;
    hasAdvanceDirective: boolean = false;
    advanceDirectiveLocation: string;
}

export class BankAccountDTO {
    accountHolder: string;
    bankName: string;
    iban: string;
    bic: string;
    mandateReferenceNumber: string;
}

export enum GENDER {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
    DIVERSE = 'DIVERSE',
    UNKNOWN = 'UNKNOWN',
}

export enum MARITAL_STATUS {
    SINGLE = 'SINGLE',
    MARRIED = 'MARRIED',
    SEPERATED = 'MARRIED',
    DIVORCED = 'DIVORCED',
    WIDOWED = 'WIDOWED',
    PARTNERED = 'PARTNERED',
    PARTNERSHIP_DISSOLVED = 'PARTNERSHIP_DISSOLVED',
    PARTNER_DIED = 'PARTNER_DIED',
    UNKNOWN = 'UNKNOWN',
}

export enum EMERGENCY_CALL_WITHOUT_VOICE {
    // CALL_AMBULANCE_AND_CONTACT = 'CALL_AMBULANCE_AND_CONTACT',
    CALL_CONTACT = 'CALL_CONTACT',
    STOP_ACTIVITIES = 'STOP_ACTIVITIES',
    CALL_AMBULANCE = 'CALL_AMBULANCE',
}

export enum MedicationType {
    GENERAL = 'GENERAL',
    SINGLE = 'SINGLE',
    CHECKBACK_GENERAL = 'CHECKBACK_GENERAL',
    CHECKBACK_SINGLE = 'CHECKBACK_SINGLE',
    CHECKBACK_PILLBOX = 'CHECKBACK_PILLBOX',
    PILLBOX = 'PILLBOX',
}

export enum KWS {
    AP,
    JUH,
    HELP,
    OFF,
}

enum LANGUAGE {
    DE,
    CH,
    AT,
    EN,
    FR,
    TR,
}

enum VOICE {
    M,
    F,
    A,
}

enum ALARM_MODE {
    SILENT,
    TALK,
    LOUD,
}

enum IOT_DEVICE {
    BLOOD_PRESSURE,
    SCALE,
    BEACON,
    SWITCH,
}

export enum ALARM_ROBBERY_AUDIO {
    STILL = 'STILL',
    MICRO_ONLY = 'MICRO_ONLY',
    NORMAL = 'NORMAL',
    SIRENE = 'SIRENE',
}

export class UserSettingCustomConfigDTO {
    id?: number;
    first_name?: string;
    last_name?: string;
    phone_number?: string;
    idType?: string;

    get fullname(): string {
        return (this.first_name || '') + '' + (this.last_name || '');
    }

    constructor(
        id?: number,
        firstName?: string,
        lastName?: string,
        phoneNumber?: string,
        idType?: string,
    ) {
        this.id = id;
        this.first_name = firstName;
        this.last_name = lastName;
        this.phone_number = phoneNumber;
        this.idType = idType;
    }
}

// export class UserSettingsAppDTO {
//     // User settings
//     title;
//     // Med Reminders active/inactive
//     medRemindersActive: boolean;
//     // wake Word active/inactive
//     wakeWordActive: boolean;
//     deprecated: true;
//     // Document Reminders
//     documentMedReminders: boolean;
//     // maximum: 6
//     // minimum: 1
//     // deprecated: true
//     // Type of medication reminder. Deprecated: Use medReminderTypeVal instead.
//     medReminderType: number;
//     // Type of medication reminder
//     medReminderTypeVal: MedicationType;
//     // Custom configuration, for easy future extensions
//     customConfig: any;
//     medicationReminderType: MedicationType;
//     constructor(
//         title,
//         medRemindersActive: boolean,
//         wakeWordActive: boolean,
//         documentMedReminders: boolean,
//         medReminderTypeVal: MedicationType,
//         customConfig: any,
//     ) {
//         // this.title = title;
//         this.medRemindersActive = medRemindersActive;
//         this.wakeWordActive = wakeWordActive;
//         this.documentMedReminders = documentMedReminders;
//         this.medReminderTypeVal = medReminderTypeVal;
//         this.customConfig = customConfig;
//     }
// }

export class UserSettingsAppDTO {
    medRemindersActive: boolean = false;
    // Med Reminders active/inactive

    // wake Word active/inactive
    // deprecated: true
    wakeWordActive: boolean;

    // Document Reminders
    documentMedReminders: boolean = false;

    // Type of medication reminder. Deprecated: Use medReminderTypeVal instead.
    // medReminderType	integer($int32)
    // maximum: 6
    // minimum: 1
    // deprecated: true

    // Type of medication reminder
    medReminderTypeVal: MedicationType;

    // Custom configuration, for easy future extensions
    customConfig: any = null;

    // Keyword Spotting mode (AP, JUH, OFF)
    kws: KWS;

    // Language (DE, CH, AT, EN, FR, TR)
    language: LANGUAGE;

    // Voice type (M, F, A)
    voice: VOICE;

    // Mode (SILENT, TALK, LOUD)
    alarmMode: ALARM_MODE;

    // IoT device type (BLOOD_PRESSURE, SCALE, BEACON, SWITCH)
    iotDevice: IOT_DEVICE;

    // Alarm Inactivity (on/off)
    alarmInactivity: boolean;

    // Alarm Deadman (on/off)
    alarmDeadman: boolean;
    // Deadman alarm timing in seconds (default: 180)
    timingAlarmDeadMan: number = 180;

    alarmDeadmanStart: string = '00:00:00';
    alarmDeadmanEnd: string = '23:59:00';
    alarmDeadmanWeekdays: DaysOfWeek;

    // Alarm Timer (on/off)
    alarmTimer: boolean;

    alarmWellBeing: boolean;

    // Timer alarm timing in seconds (default: 180)
    timingAlarmTimer: number = 180;

    // Alarm Robbery (on/off)
    alarmRobbery: boolean;

    // Robbery alarm timing in seconds (TBD)
    timingAlarmRobbery: number = 10;

    // Alarm robbery audio mode (STILL, MICRO_ONLY, NORMAL, SIRENE)
    alarmRobberyAudio: ALARM_ROBBERY_AUDIO = ALARM_ROBBERY_AUDIO.STILL;

    // Alarm Escape (on/off)
    alarmEscape: boolean;

    // Escape alarm timing in seconds (default: 6)
    timingAlarmEscape: number;

    // Alarm Loss (on/off)
    alarmLoss: boolean;

    // Alarm Geo (on/off)
    alarmGeo: boolean;

    // Alarm Seizure (on/off)
    alarmSeizure: boolean;

    // Seizure alarm timing in seconds (default: 6)
    timingAlarmSeizure: number = 6;

    // maximum: 10
    // minimum: 1
    // Seizure detection sensitivity (1-10, default: 5)
    alarmSeizureSensitivity: number = 5;

    // Alarm Extended fall detection (on/off)
    alarmExtendedFallDetection: boolean;

    // maximum: 10
    // minimum: 1
    // Extended fall detection sensitivity (1-10, default: 5)
    alarmExtFallSensitivity: number = 5;

    // Timed alarm Extended fall detection (default: 15)
    timingAlarmExtendedFallDetection: number = 15;

    // Line check timing in seconds (default: 1800)
    timingLineCheck: number;

    // Loss alarm timing in seconds (default: 180)
    timingAlarmLoss: number;

    // Alarm Position (on/off)
    alarmPosition: boolean;

    // Position alarm timing in seconds (default: 20)
    timingAlarmPosition: number = 20;

    // maximum: 180
    // minimum: 0
    // Position alarm degree (0-180, default: 40)
    alarmPositionDegree: number = 40;

    // Watch face long press number
    watchfaceLongpressNumber: string;

    medicationReminderType: MedicationType;

    receivePushNotifications = true;

    personalDataUploadEnabled = true;

    constructor(
        title,
        medRemindersActive: boolean,
        wakeWordActive: boolean,
        documentMedReminders: boolean,
        medReminderTypeVal: MedicationType,
        customConfig: any,
    ) {
        // this.title = title;
        this.medRemindersActive = medRemindersActive;
        this.wakeWordActive = wakeWordActive;
        this.documentMedReminders = documentMedReminders;
        this.medReminderTypeVal = medReminderTypeVal;
        this.customConfig = customConfig;
    }
}

export class UserDTO {
    userId: number = 0;
    // active?: boolean;
    // status?: string;
    // avatar?: string;
    login: string;
    firstName: string;
    lastName: string;
    nickName: string;
    title: string;
    firstLanguage: string;
    colloqAdd = true;
    salutation: string;
    sex: GENDER = GENDER.MALE;
    maritalStatus: MARITAL_STATUS = MARITAL_STATUS.SINGLE;
    address: AddressDTO;
    residence: ResidienceDTO;
    cohabitingSituation: CohabitingSituationDTO;
    medicalUserData: MedicalUserDataDTO;
    bankAccount: BankAccountDTO;
    birthday: string | Date;
    age = 0;
    email: string;
    phoneHome: string;
    phoneMobile: string;
    partnerId: string;
    phoneEmergencyNumber: string;
    waitUntilDisponentTalks = true;
    isAgent = true;
    userEmergencyId: string;
    interests: string;
    notesMedicalPreconditions: string;
    notesSocialEnvironment: string;
    actionForEmergencyCallWithoutVoice: EMERGENCY_CALL_WITHOUT_VOICE =
        EMERGENCY_CALL_WITHOUT_VOICE.CALL_AMBULANCE;
    authorities: [];
    roles: string;
    b2bCustomer;
}
